import * as types from "./types";
import {

    getMarketingLead,
    getMarketingLeadById,
    postMarketingLead,
    putMarketingLead,
    deleteMarketingLead,
    convertToSales
} from "./services";



export async function getMarketingLeadAction({ commit }) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        const { data } = await getMarketingLead();
        console.log(data);
        commit(types.GET_MARKETINGLEADS, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }
}

export async function getMarketingLeadByIdAction({ commit }, id) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        const { data } = await getMarketingLeadById(id);
        commit(types.GET_MARKETINGLEADS_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }
}

export async function postMarketingLeadAction({ commit }, payload) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        await postMarketingLead(payload);
        commit(types.POST_MARKETINGLEADS_ID, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }
}

export async function putMarketingLeadAction({ commit }, payload) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        await putMarketingLead(payload);
        commit(types.UPDATE_MARKETINGLEADS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }
}


export async function deleteMarketingLeadAction({ commit }, id) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        await deleteMarketingLead(id);
        commit(types.DELETE_MARKETINGLEADS, id);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }
}


export async function convertToSalesAction({ commit }, id) {
    commit(types.LOADING_MARKETINGLEADS, true);
    try {
        await convertToSales(id);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_MARKETINGLEADS, false);
    }

}